<div class="event-card border border-grey-200 rounded-lg p-4 bg-white shadow-sm"
     [ngClass]="{'clickable': !readonly}"
     (click)="openEvent()">
  <div class="flex items-start justify-between gap-3">
    <div class="flex-1">
      <p class="text-xs uppercase tracking-wide text-grey-600 mb-1">Location</p>
      <p class="text-lg font-semibold">{{event.LocationName}}</p>
      <p class="text-sm text-grey-700">{{event.LocationQuestion}}</p>
      <p class="text-sm text-grey-700">{{event.TypeQuestion}}</p>
      <p class="mt-2 text-grey-900">{{event.SummaryQuestion}}</p>
    </div>
    <div class="text-right border-l border-grey-200 pl-4 min-w-[160px]">
      <p class="text-xs uppercase tracking-wide text-grey-600 mb-1">Reported</p>
      <p class="font-semibold">{{event.DateQuestion}}</p>
      <p class="text-sm text-grey-700">By {{event.UserCreated}}</p>
      <p class="text-sm text-grey-700 mt-2">Status: <span class="font-semibold">{{event.EventStatus}}</span></p>
      <p class="text-sm text-grey-700 mt-1">Risk: {{event.RiskQuestion}}</p>
    </div>
  </div>
</div>
